import { createSlice } from "@reduxjs/toolkit";
import { generalApiTemplate, generalApiResponseTemplate } from "../apiTemplate";

const initialState = {
  loading: "idle",
  entities: {},
  currentRequestId: undefined,
  error: [],
};

export const getInvoices = () => {
  return generalApiTemplate({
    storeName: "auth",
    _url: `finance/invoice`,
    method: "GET",
  });
};

export const invoiceSlice = createSlice({
  name: "getInvoice",
  initialState,
  reducers: {
    resetAction: () => {
      return initialState;
    },
  },
  extraReducers: generalApiResponseTemplate(getInvoices()),
});